import {useStoreSelector} from "./redux/useStoreSelector";
import {useCallback, useEffect} from "react";
import {useApi} from "./useApi";
import {dispatcher} from "../store";


export function usePortfolios() {
  const portfolios = useStoreSelector( s => s.portfolios.list),
    {api, isAuth} = useApi()

  const loader = useCallback( async () => {
    if (isAuth) {
      const res = await api.getPortfolios({})
      if (res.status === 200) {
        dispatcher.portfolios.setList(res.body)
      }
    }
  }, [api, isAuth])

  useEffect(() => {
    if (!portfolios) {
      loader().catch(console.error)
    }
  }, [loader, portfolios])

  return {portfolios, loader}
}
